import { Component, Input } from '@angular/core';
import { BudgetService } from '../service/budget.service';

@Component({
  selector: 'apc-budget-summary-modal',
  templateUrl: './budget-summary-modal.component.html',
  styleUrls: ['./budget-summary-modal.component.scss', '../budget-filler/budget-filler.component.scss'],
  providers: [BudgetService]
})
export class BudgetSummaryModalComponent {
  @Input() modalRef: any;
  @Input() orderId: any;
  @Input() budgets: any;
  selectedTab: string = 'budgets';
  close() {
    this.modalRef.dismiss();
  }

  selectTab(tab: string){
    this.selectedTab = tab;
  }
}
